import { process } from '../mock';

export default function ProcessSection() {
  return (
    <section className="bg-white py-24 lg:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-4">
              — How It&rsquo;s Made
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] leading-[1.05]">
              Six steps. Zero compromises.
            </h2>
          </div>
          <p className="lg:col-span-6 lg:col-start-7 text-neutral-600 leading-relaxed text-lg">
            From raw wire to shop-floor-ready cartons, every electrode passes through six
            meticulous stages inside our Kota facility — the same process refined over four
            decades of manufacturing.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-neutral-200 border border-neutral-200 rounded-2xl overflow-hidden">
          {process.map((p) => (
            <div
              key={p.step}
              className="group bg-white p-8 hover:bg-[#0b0b0d] transition-colors duration-300 cursor-default"
            >
              <div className="font-display text-5xl font-semibold text-neutral-200 group-hover:text-amber-400 transition-colors">
                {p.step}
              </div>
              <h3 className="mt-4 font-display text-xl font-semibold text-[#0b0b0d] group-hover:text-white transition-colors">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-neutral-600 group-hover:text-white/70 transition-colors leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
